import React, { Component } from 'react'
import { Link, HashRouter } from 'react-router-dom'
import { setRegPage, currentWidget, popupOpenClose, setMobileTVPage, setDeviceConfigFailed, setFailScreen, openSMSWidget, setOpenProfileImage, setMultiSubWidget } from '../../action/action'
import { connect } from 'react-redux'
import { setRoomControlPage } from '../../layout2.0/action/action'
import { nonCompWidgetClick } from '../../layout2.0/JS/widgetHandling'
import { setLoginRequired, setOpenDemoCamera } from '../../layout2.0/action/homeAction'
import { closeOrderPopUp } from '../../layout2.0/action/hCommerce2'
import { setHcommerceWidget } from '../../layout2.0/action/hCommerce2';
import { setDNDon, setMURon, setGoHome, setLoader } from '../../layout2.0/action/homeAction';
import { sendAcCommand } from '../../action/roomControlAction'
import { guestDetails, sendAnalytics } from '../../action/homeAction'
import { withTranslation } from 'react-i18next'
import { CMSPath } from '../../config/constant'
import { scrollToTop } from '../../JS/scrollToTop'
import { setOpenExternalLinkInSameTab } from '../../layout2.0/action/homeAction'


class ListMultiSubWidget extends Component {

    constructor(props) {
        super(props);
    }

    setRoomControlPageOnClick = (widget) => {
        switch (widget.widgetType) {
            case "Room Theme":
                this.props.setRoomControlPage("roomTheme");
                break;
            case "Room Temperature":
                this.props.setRoomControlPage("AcControl");
                break;
            case "Speaker":
                this.props.setRoomControlPage("speakerControl");
                break;
            case "Smart Window Control":
                this.props.setRoomControlPage("windowTintControl");
                break;
            default:
                console.log("no room control path is matching.")
                break;
        }
    }

    onWidgetClick = async (widget) => {
        let room = localStorage.getItem('room')
        console.log("current widget", widget)
        if (widget.path) {
            await this.props.currentWidget(widget);
            if (widget.path === "/RoomControl2") {
                this.setRoomControlPageOnClick(widget);
            }
            if (widget.path === "/mobileTv") {
                if (!room) {
                    if (process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                } else {
                    this.props.setMobileTVPage(true);
                }
            }
            if (widget.widgetType === "Hcommerce") {
                this.props.setHcommerceWidget(widget);
            }
            if (widget.path === "/happy") {
                if (this.props.survey.needsLogin)
                    if (!room || room === "null") {
                        if (process.env.REACT_APP_INROOMTAB == "true") {
                            this.props.setLoginRequired(true)
                        } else {
                            this.props.setRegPage(true);
                        }
                    }
            }
        } else {
            nonCompWidgetClick({...widget, dontSetCurrentWidget: true}, this.props)
        }
    }

    goHome() {
        this.props.setGoHome(true);
    }

    componentDidMount() {
        scrollToTop();
        this.props.currentWidget({ widgetType: "multiSubWidget" })

        if (Object.keys(this.props.multiSubWidget).length == 0 || (Object.keys(this.props.multiSubWidget).length > 0 && this.props.multiSubWidget.subWidgetMap.length == 0)) {
            this.props.setFailScreen(true, "", "Something went wrong", true)
            this.goHome();
        }
    }

    componentWillUnmount() {
        // this.props.currentWidget({});
        this.props.setMultiSubWidget({});
    }

    render() {
        return (
            <div id="multi-sub-widget-list">
                <header class="inner-pages subpages">
                    <a onClick={() => this.goHome()} className="button-back"></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p className="bold" style={{ color: "inherit" }}>{this.props.multiSubWidget.widgetTitle}</p> */}
                    </div>
                </header>
                <section class={`widgets spa-listing  ${this.props.selectedHomePage.uniqueKey}`}>

                    <div class="widget-header">
                        <div class="widget-header-title" dangerouslySetInnerHTML={{__html: this.props.multiSubWidget.displayName}} ></div>
                    </div>

                    <div class="row">
                        <div class="col sm-banner">
                            <div class="col sm-banner">
                                {Object.keys(this.props.multiSubWidget).length > 0 && this.props.multiSubWidget.subWidgetMap.length > 0 ?
                                    this.props.multiSubWidget.subWidgetMap.map((iterator) => {
                                        return (
                                            <Link id={iterator.widgetType} className={'tile-sm thumbnails tile-container'}
                                                onClick={() => {this.onWidgetClick(iterator) }}
                                                exact to={iterator.path ? iterator.path : '/MultiSubWidgetList'}
                                            >
                                                <div class="thumb-img">
                                                    {iterator.compImage ?
                                                        <img src={iterator.compImage}></img> :
                                                        ""
                                                    }
                                                </div>

                                                <div class="thumb-text">
                                                    <p class="thumb-heading" dangerouslySetInnerHTML={{__html: iterator.widgetTitle ? iterator.widgetTitle : ""}} ></p>
                                                    <p dangerouslySetInnerHTML={{__html: iterator.widgetDesc ? iterator.widgetDesc : ""}}></p>
                                                </div>
                                            </Link>
                                        )
                                    }) : ""
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        multiSubWidget: state.store2.multiSubWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        appLauncherWidget: state.store.appLauncher.widget,
        DND: state.store.InncomRoomControl.DND ?
            state.store.InncomRoomControl.DND : null,
        MUR: state.store.InncomRoomControl.MUR ?
            state.store.InncomRoomControl.MUR : null,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        selectedHomePage: state.store2.currentHomePage,
        roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,

    }
}
export default connect(
    mapStateToProps,
    {
        currentWidget,
        popupOpenClose,
        openSMSWidget,
        setOpenProfileImage,
        setRoomControlPage,
        setDeviceConfigFailed,
        setOpenDemoCamera,
        setRegPage,
        setOpenExternalLinkInSameTab,
        closeOrderPopUp,
        setHcommerceWidget,
        setDNDon,
        setMURon,
        setMobileTVPage,
        sendAcCommand,
        sendAnalytics,
        setGoHome,
        setLoader,
        setMultiSubWidget,
        setFailScreen,
        setLoginRequired,
        guestDetails
    }
)(withTranslation('translations')(ListMultiSubWidget));